import { css } from '@emotion/react';
import { ReactElement } from 'react';
import { ComponentType } from 'react';

import { styled } from '../../../../styled';
import { Theme } from '../../../../theme/interface/detailed';
import { useSanitize } from '../../../../utils/useSanitize';

const styles = css`
	align-items: center;
	display: flex;
	justify-content: space-around;

	& > img {
		border-radius: 15px;
		height: 30px;
		width: 30px;
	}

	& > div {
		padding: 5px;
		text-align: center;
	}
`;

type Interface = {
	className: string;
	message: string;
};

const Component = ({ className, message }: Interface): ReactElement => {
	const sanitizedHtml = useSanitize(message);
	return <div className={className}>{sanitizedHtml && <div dangerouslySetInnerHTML={sanitizedHtml} />}</div>;
};

export const SystemMessage = styled(Component)(
	({ theme }: { theme: Theme }) => theme.chat.systemMessages.systemMessage,
	styles
) as ComponentType<Partial<Interface>>;
